<script lang="ts" setup>
import Button from 'primevue/button';
import BaseIcon from './BaseIcon.vue';

withDefaults(
  defineProps<{
    label?: string;
    icon?: string;
    loading?: boolean;
    unstyled?: boolean;
    fluid?: boolean;
  }>(),
  {
    fluid: true,
  },
);
</script>

<template>
  <Button :fluid :loading :unstyled :class="unstyled ? '' : 'rounded-lg!'">
    <slot>
      <BaseIcon v-if="!loading && icon" :name="icon" size="sm" />
      <BaseIcon
        v-if="loading"
        class="material-symbols-outlined animate-spin"
        name="progress_activity"
        size="sm"
      />
      <span v-if="label">{{ label }}</span>
    </slot>
  </Button>
</template>
